var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoKingN(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 177.8 29",
    style: {
      enableBackground: "new 0 0 177.8 29"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#F2BF30;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#CC9932;}\r\n\t.st2{enable-background:new    ;}\r\n\t.st3{fill:#FAFAFA;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "35.3,28 23,28 39,9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "3.7,28 0,9 16,28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "20,28 12,18.3 12.1,18 19.9,0 28,18.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "20,0.5 19.8,0 11.2,18 11,18.3 19.8,28 20,27.8  "
  }), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M60.3,17.7l-1.6,1.7v3.8h-4.2V8.1h4.2v6.3l5.9-6.3h4.7l-6.2,6.7l6.5,8.4h-5L60.3,17.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M70.4,9.6c-0.5-0.4-0.7-0.9-0.7-1.6s0.2-1.1,0.7-1.6c0.5-0.4,1.1-0.6,1.8-0.6C73,5.8,73.6,6,74,6.4 c0.5,0.4,0.7,0.9,0.7,1.5c0,0.6-0.2,1.2-0.7,1.6c-0.5,0.4-1.1,0.6-1.8,0.6C71.5,10.2,70.9,10,70.4,9.6z M70.2,11.5h4.1v11.7h-4.1 V11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M88.5,12.6c0.9,0.9,1.3,2.2,1.3,3.9v6.7h-4.1v-6c0-1.6-0.6-2.4-1.9-2.4c-0.7,0-1.3,0.2-1.7,0.7 s-0.6,1.2-0.6,2.1v5.7h-4.1V11.5h3.9v1.3c0.5-0.5,1-0.8,1.6-1.1s1.3-0.4,2.1-0.4C86.4,11.3,87.6,11.7,88.5,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M105.6,11.5v9.6c0,2.2-0.6,3.8-1.8,4.9s-2.9,1.6-5.1,1.6c-1.2,0-2.2-0.1-3.2-0.4c-1-0.3-1.9-0.6-2.6-1.1 l1.5-2.9c0.5,0.4,1.1,0.7,1.8,0.9c0.7,0.2,1.4,0.3,2.1,0.3c1.1,0,1.9-0.2,2.4-0.7c0.5-0.5,0.8-1.2,0.8-2.1v-0.4 c-0.8,0.9-2,1.4-3.5,1.4c-1,0-2-0.2-2.9-0.7s-1.6-1.1-2.1-2s-0.8-1.8-0.8-3c0-1.1,0.3-2.1,0.8-2.9c0.5-0.9,1.2-1.5,2.1-2 s1.8-0.7,2.9-0.7c1.7,0,2.9,0.5,3.7,1.6v-1.4H105.6z M100.8,18.7c0.5-0.4,0.7-1,0.7-1.7c0-0.7-0.2-1.3-0.7-1.7 c-0.5-0.4-1.1-0.7-1.8-0.7s-1.4,0.2-1.8,0.7c-0.5,0.4-0.7,1-0.7,1.7c0,0.7,0.2,1.3,0.7,1.7s1.1,0.7,1.8,0.7 S100.3,19.1,100.8,18.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M119.4,12.6c0.9,0.9,1.3,2.2,1.3,3.9v6.7h-4.1v-6c0-1.6-0.6-2.4-1.9-2.4c-0.7,0-1.3,0.2-1.7,0.7 s-0.6,1.2-0.6,2.1v5.7h-4.1V11.5h3.9v1.3c0.5-0.5,1-0.8,1.6-1.1s1.3-0.4,2.1-0.4C117.3,11.3,118.5,11.7,119.4,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M125.9,22.6c-1-0.5-1.8-1.2-2.4-2.2c-0.6-0.9-0.9-2-0.9-3.1c0-1.2,0.3-2.2,0.9-3.1c0.6-0.9,1.4-1.6,2.4-2.1 c1-0.5,2.1-0.8,3.4-0.8s2.4,0.3,3.4,0.8c1,0.5,1.8,1.2,2.4,2.1c0.6,0.9,0.8,2,0.8,3.1c0,1.2-0.3,2.2-0.8,3.1s-1.3,1.6-2.4,2.2 s-2.1,0.8-3.4,0.8C128.1,23.4,126.9,23.1,125.9,22.6z M131.1,19.4c0.5-0.5,0.7-1.2,0.7-2.1c0-0.9-0.2-1.5-0.7-2s-1.1-0.7-1.8-0.7 s-1.3,0.2-1.8,0.7s-0.7,1.2-0.7,2c0,0.9,0.2,1.6,0.7,2.1s1.1,0.7,1.8,0.7S130.6,19.9,131.1,19.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M150.1,7.2v16h-3.9V22c-0.8,0.9-1.9,1.4-3.4,1.4c-1.1,0-2-0.2-2.9-0.7c-0.9-0.5-1.6-1.2-2.1-2.1 c-0.5-0.9-0.8-2-0.8-3.2c0-1.2,0.3-2.3,0.8-3.2c0.5-0.9,1.2-1.6,2.1-2.1c0.9-0.5,1.9-0.7,2.9-0.7c1.4,0,2.5,0.4,3.2,1.2V7.2 H150.1z M145.4,19.4c0.5-0.5,0.7-1.2,0.7-2.1c0-0.9-0.2-1.5-0.7-2c-0.5-0.5-1-0.7-1.8-0.7s-1.3,0.2-1.8,0.7s-0.7,1.2-0.7,2 c0,0.9,0.2,1.6,0.7,2.1s1.1,0.7,1.8,0.7C144.4,20.1,144.9,19.9,145.4,19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M165.1,18.4h-8.5c0.2,0.6,0.5,1.1,1,1.4c0.5,0.3,1.1,0.5,1.9,0.5c0.6,0,1-0.1,1.5-0.2s0.8-0.4,1.2-0.8 l2.2,2.2c-1.1,1.3-2.8,1.9-5,1.9c-1.4,0-2.6-0.3-3.6-0.8c-1-0.5-1.8-1.2-2.4-2.2c-0.6-0.9-0.9-2-0.9-3.1c0-1.2,0.3-2.2,0.8-3.1 c0.6-0.9,1.3-1.6,2.3-2.1c1-0.5,2.1-0.8,3.3-0.8c1.2,0,2.2,0.2,3.2,0.7s1.7,1.2,2.3,2.1c0.6,0.9,0.8,2,0.8,3.3 C165.2,17.4,165.2,17.7,165.1,18.4z M157.3,14.8c-0.4,0.4-0.7,0.8-0.8,1.5h4.8c-0.1-0.6-0.4-1.1-0.8-1.5c-0.4-0.4-1-0.5-1.6-0.5 S157.8,14.4,157.3,14.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M168.7,23.1c-1-0.2-1.7-0.5-2.3-0.9l1.2-2.8c0.5,0.3,1.2,0.6,1.9,0.8s1.5,0.3,2.2,0.3c0.7,0,1.1-0.1,1.4-0.2 c0.3-0.1,0.4-0.3,0.4-0.6c0-0.3-0.2-0.4-0.5-0.6c-0.3-0.1-0.9-0.2-1.6-0.3c-0.9-0.1-1.7-0.3-2.4-0.5c-0.7-0.2-1.2-0.5-1.7-1 c-0.5-0.5-0.7-1.2-0.7-2.1c0-0.7,0.2-1.4,0.7-2s1.1-1,2-1.4c0.9-0.3,1.9-0.5,3.1-0.5c0.8,0,1.7,0.1,2.5,0.3 c0.8,0.2,1.5,0.4,2.1,0.7l-1.2,2.8c-1-0.6-2.2-0.9-3.4-0.9c-0.6,0-1.1,0.1-1.4,0.2c-0.3,0.2-0.5,0.3-0.5,0.6 c0,0.3,0.2,0.5,0.5,0.6c0.3,0.1,0.9,0.2,1.6,0.3c1,0.1,1.8,0.3,2.4,0.5c0.6,0.2,1.2,0.5,1.7,1c0.5,0.5,0.7,1.2,0.7,2.1 c0,0.7-0.2,1.4-0.7,2s-1.1,1-2,1.4s-1.9,0.5-3.1,0.5C170.6,23.4,169.6,23.3,168.7,23.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKingN);
export default __webpack_public_path__ + "static/media/LogoKingN.b80630bad02af42bdd9c95c493723624.svg";
export { ForwardRef as ReactComponent };